import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
  useCallback,
} from "react";
import { useNavigate } from "react-router-dom";
import { server } from "./server";
import axios from "axios";
import { toast } from "react-toastify";
const AuthContext = createContext({});
export const Authentication = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loadingInitial, setLoadingInitial] = useState(true);
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(true);

  const changeMenuSize = useCallback(() => {
    setMenuOpen((prev) => !prev);
  }, []);

  useEffect(() => {
    const verifyToken = localStorage.getItem("dbToken");

    if (verifyToken) {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${verifyToken}`);

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${server}/auth/Profile`, requestOptions)
        .then((response) => response.text())
        .then((result) => {
          if (result) {
            try {
              const parsedData = JSON.parse(result);
              if (parsedData?.data && Object.keys(parsedData.data).length > 0) {
                setUser(parsedData.data);
              } else {
                console.warn("Profile data is empty or invalid");
                setUser(null);
                localStorage.removeItem("dbToken");
              }
            } catch (e) {
              console.error("Failed to parse profile response:", e);
              setUser(null);
              localStorage.removeItem("dbToken");
            }
          } else {
            setUser(null);
          }
          setLoadingInitial(false);
        })
        .catch((error) => {
          console.log("Profile fetch error", error);
          toast.error(error?.message || "Failed to load profile!");
          setUser(null);
          localStorage.removeItem("dbToken");
          setLoadingInitial(false);
        });
    } else {
      setLoadingInitial(false);
    }
  }, []);

  const loginWithEmailAndPassword = useCallback(async (email, password) => {
    setLoading(true);
    try {
      const { data } = await axios.post(`${server}/auth/Login`, {
        mobileNo: email,
        password,
      });

      // Check if user data exists in response
      if (data?.data && data?.token) {
        setUser(data.data);
        localStorage.setItem("dbToken", data.token);
        setToken(data.token);
      } else {
        // If no user data, treat as failed login
        console.warn("Login response missing user data:", data);
        toast.error("Login failed: Invalid user data received");
        setUser(null);
        setToken(null);
        localStorage.removeItem("dbToken");
      }
    } catch (e) {
      toast.error(e?.response?.data?.message || "Something went wrong!");
      setUser(null);
      setToken(null);
      localStorage.removeItem("dbToken");
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(() => {
    setLoading(true);
    try {
      setUser(null);
      localStorage.clear();
      navigate("/login");
      setLoading(false);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  const memoValues = useMemo(
    () => ({
      user,
      loading,
      loginWithEmailAndPassword,
      logout,
      token,
      menuOpen,
      changeMenuSize,
    }),
    [user, loading, loginWithEmailAndPassword, logout, token, menuOpen, changeMenuSize],
  );
  return (
    <AuthContext.Provider value={memoValues}>
      {!loadingInitial && children}
    </AuthContext.Provider>
  );
};

export default function useAuth() {
  return useContext(AuthContext);
}
